import { RegisterLeaveCombinedComponent } from './../../visit-overview/component/register-leave-combined/register-leave-combined.component';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { TransportDetailsLayoutConverter } from './../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from './../../../common/configuration/transport.configuration';
import { Component, Input } from '@angular/core';
import { ActionItem, AppClientConfiguration, AppClientConfigurationService, AppServerAPI } from '@sdbn/common';
import { AsyncSubject, interval, Subscription } from 'rxjs';
import { Transport } from '../../../common/model/transport.model';
import { TransportDetailsLayoutService } from '../../transport-details/transport-details-layout.service';
import { DialogService } from '@sdbn/common';
import { RegisterLeaveComponent } from '../../visit-overview/dialog/register-leave/component/register-leave.component';

@Component({
    selector: 'app-action-tablet-refused-leave',
    templateUrl: './action-tablet-refused-leave.component.html',
    styleUrls: ['./action-tablet-refused-leave.component.scss'],
    standalone: false
})
export class ActionTabletRefusedLeaveComponent {

  TransportDetailMode = TransportDetailMode;

  layoutDefinition: TransportDetailLayout;

  @Input() actionItem: ActionItem;

  urls: Array<string>;

  timerSubscription: Subscription;

  transports = new Array<Transport>();

  clientParameters = TMCClientParameters;

  constructor(
    private httpService: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    public cps: AppClientConfigurationService,
    private dialogService: DialogService
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );

  }

  ngOnInit(): void {


    this.loadProfiles();

    if (this.actionItem.refreshTimer > 0) {

      this.timerSubscription = interval(this.actionItem.refreshTimer * 1000).subscribe(n => {
        this.loadProfiles();
      });
    }

  }

  private loadProfiles(): AsyncSubject<void> {

    var data = JSON.parse(this.actionItem.data);

    const subject = new AsyncSubject<void>();
    this.httpService.execute<Array<any>>('/tmc-yard/access/leave/findRefusedLeaves', { id: data.areaGateId }).subscribe(response => {

      let transports = new Array<Transport>();
      for (const transport of response) {
        transports.push(new Transport(transport));
      }
      this.transports = transports;
      subject.next();
      subject.complete();

    }, error => {
      subject.error('');
    });
    return subject;
  }

  public handleLeave(transport: Transport) {

    if (this.cps.isPropertyTrue(this.clientParameters.FEATURES_COMBINED_LEAVE, false)) {

      this.dialogService.openDefault(RegisterLeaveCombinedComponent, { transportId: transport.id }).afterClosed().subscribe(result => {
        this.loadProfiles().subscribe(() => { });
      });

    } else {

      this.dialogService.openDefault(RegisterLeaveComponent, { transportId: transport.id }).afterClosed().subscribe(result => {
        this.loadProfiles().subscribe(() => { });
      });
    }

  }

  public handleCancel(transport: Transport) {

    this.dialogService.showConfirm('tmc-yard.access.refused-transport-action-item.confirm-delete-title',
      'tmc-yard.access.refused-transport-action-item.confirm-delete-description').afterClosed().subscribe(result => {

        if (result) {
          this.httpService.execute<Array<any>>('/tmc-yard/access/leave/markRefuedLeaveProcessed', { id: transport.id }).subscribe(response => {
            this.loadProfiles().subscribe(() => { });
          });

        }

      });

  }

}
